export const lbs = 0.0625; //oz
export const oz = 16; //lbs
export const lbsCode = "lb";
export const ozCode = "oz";
